import { render, staticRenderFns } from "./SocialSharing.vue?vue&type=template&id=0a30fc08"
import script from "./SocialSharing.vue?vue&type=script&lang=js"
export * from "./SocialSharing.vue?vue&type=script&lang=js"
import style0 from "./SocialSharing.vue?vue&type=style&index=0&id=0a30fc08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports